module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-einvoice-status"
  }, [_c('ActionButton', {
    attrs: {
      "slot": "trigger",
      "action": _vm.getStatus
    },
    slot: "trigger"
  }, [_vm._v("Status SDI")]), _c('ModalReveal', {
    on: {
      "input": _vm.closeSdiStatus
    },
    model: {
      value: (_vm.openSdiStatus),
      callback: function($$v) {
        _vm.openSdiStatus = $$v
      },
      expression: "openSdiStatus"
    }
  }, [(_vm.sdiStatus) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Status fattura")]), _c('div', {
    staticClass: "fname"
  }, [_vm._v("Nome file: " + _vm._s(_vm.sdiStatus.filename))]), _c('div', {
    staticClass: "ecode"
  }, [_vm._v("Errore: " + _vm._s(_vm.sdiStatus.errorCode) + " " + _vm._s(_vm.sdiStatus.errorDescription))]), _c('div', {
    staticClass: "download"
  }, [_vm._v("Apri XML ricevuto dallo SDI")]), _c('div', {
    staticClass: "download"
  }, [_vm._v("(CTRL+U per vedere il contenuto)")]), _c('a', {
    staticClass: "fa fa-code fa-2x",
    on: {
      "click": _vm.openSentXml
    }
  }), _c('hr'), _vm._l((_vm.sdiStatus.invoices), function(status) {
    return _c('div', {
      staticClass: "status"
    }, [_c('div', {
      staticClass: "line"
    }, [_vm._v("N° " + _vm._s(status.number) + " - " + _vm._s(status.status) + " " + _vm._s(status.description))]), _c('div', {
      staticClass: "line"
    }, [_vm._v(_vm._s(status.statusDescription))])])
  })], 2)])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30f47178!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/modules/einvoice/EinvoiceGetStatus.vue
// module id = 2384
// module chunks = 1